import { App } from 'app/console-api';
import { BodyText, FlexColumn, FlexRow, SvgIcon } from '@make-software/cspr-design';
import { CategoryTag } from 'app/components/common/categories/category-tag';
import React from 'react';
import LinkIcon from 'assets/icons/ic-link.svg';
import InfoIcon from 'assets/icons/ic-info.svg';
import styled from 'styled-components';
import { StyledTooltip } from 'app/components/common/common-styles';
import { NavLink, generatePath } from 'react-router-dom';
import { PUBLIC_APP_VIEW_PATH } from 'app/route/paths';

export interface AppShortPreviewProps {
  app: App;
}

const ItemArea = styled(FlexColumn)(({ theme }) =>
  theme.withMedia({
    borderRadius: '4px',
    background: '#F5F5F7',
    padding: '16px'
  })
);

const StyledCaption = styled.div(({ theme }) =>
  theme.withMedia({
    color: '#1A1919',
    fontSize: '14px',
    fontWeight: '600',
    lineHeight: '20px'
  })
);

export const AppShortPreview = ({ app }: AppShortPreviewProps) => {
  return (
    <FlexColumn>
      <ItemArea gap={16}>
        <FlexColumn gap={4}>
          <StyledCaption>
            <FlexRow gap={4}>
              <NavLink to={generatePath(PUBLIC_APP_VIEW_PATH, { appId: app.id })}>
                {app.name} <SvgIcon src={LinkIcon} size={12} />
              </NavLink>
            </FlexRow>
          </StyledCaption>
          <BodyText size={2} scale={'xs'} variation={'darkGray'}>
            {app.description}
          </BodyText>
        </FlexColumn>

        <FlexColumn gap={4}>
          <FlexRow gap={8} align={'center'}>
            <BodyText size={3} scale={'sm'} variation={'darkGray'}>
              MAU:
            </BodyText>
            <BodyText size={3} scale={'sm'} monotype>
              {app.mau.toLocaleString()}
            </BodyText>
            <StyledTooltip tooltipContent="Monthly active users">
              <SvgIcon src={InfoIcon} color={'gray'} />
            </StyledTooltip>
          </FlexRow>
          <FlexRow gap={8} align={'center'}>
            <BodyText size={3} scale={'sm'} variation={'darkGray'}>
              DAU:
            </BodyText>
            <BodyText size={3} scale={'sm'} monotype>
              {app.dau.toLocaleString()}
            </BodyText>
            <StyledTooltip tooltipContent="Daily active users">
              <SvgIcon src={InfoIcon} color={'gray'} />
            </StyledTooltip>
          </FlexRow>
          <FlexRow gap={8}>
            {app.categories.map((categoryName) => (
              <CategoryTag key={categoryName} name={categoryName} />
            ))}
          </FlexRow>
        </FlexColumn>
      </ItemArea>
    </FlexColumn>
  );
};
